export const LOD_LOW = 0.1;
export const LOD_LOW_HIGH = 0.3;
export const LOD_MEDIUM = 0.5;
export const LOD_HIGH = 1;

export const LOD_PRIORITIES = [LOD_HIGH, LOD_MEDIUM, LOD_LOW_HIGH, LOD_LOW];

export const LOW_ZOOM_PREVIEW_MAX_SCREEN_PX = 384;
export const LOD_SOURCE_OVERSAMPLE = 1.75;
export const LOD_MIN_CANVAS_SIDE = 96;
export const LOD_LOW_MAX_CANVAS_SIDE = 640;
export const LOD_LOW_HIGH_MAX_CANVAS_SIDE = 1024;
export const LOD_MEDIUM_MAX_CANVAS_SIDE = 1600;
